import axios from 'axios';


class Rest {

  constructor() {
    this.base = process.env.VUE_APP_API_ENDPOINT || '';
    this.axios = axios.create(this.defaults);
  }

  async request(method, url, data, params) {
    try {
        const response = await this.axios({
            url: this.base + url,
            method,
            data: data || {},
            params: params || {},
            withCredentials: true,
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-CSRFToken',
        });
        return response.data || {};
    } catch (error) {
        const status = error.response ? error.response.status : undefined;
        const err = Error(`Error: ${error}`);
        err.api = true;
        err.inner = error;
        err.status = status;
        err.data = error.response ? error.response.data || {} : {};
        throw err;
    }
  }

  // get request
  async get(url, params) {
    return this.request('get', url, null, params);
  }

  // put request
  async put(url, data, params) {
    return this.request('put', url, data, params);
  }

  // post request
  async post(url, data, params) {
    return this.request('post', url, data, params);
  }

  // delete request
  async delete(url, params) {
    return this.request('delete', url, null, params);
  }
}

export default new Rest();
